import React from 'react'

export const ServiceCatalogIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="2"
      y="2"
      width="12"
      height="5"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <rect
      x="2"
      y="9"
      width="12"
      height="5"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M5 4.5h4M5 11.5h6"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
)
